module.exports = __webpack_public_path__ + "static/media/doclad14.48b30e9d.pdf";